<template>
  <main class="main page home">
    <div class="header__section">
      <div class="column home__header">
        <div class="container">
          <TitleBlock
            v-if="basicPage && basicPage.body && basicPage.body.length"
            text="New! Vixio Workspace"
            color="brightgreen"
            :padding="false"
          />
          <TextContent
            v-if="basicPage && basicPage.body && basicPage.body.length"
            :content="basicPage.body"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <ChecklistOverview class="column" />
      </div>
      <div class="row">
        <div class="column column--2-3">
          <!-- FEATURED -->
          <div
            v-if="featured && featured.length"
            class="main__featured section section-border--top section-border--right section-border--bottom feat_cont"
          >
            <TitleBlock :text="'Featured'" color="corporateblue" />
            <el-row>
              <el-col
                v-for="(article, index) in featured.slice(0, 3)"
                :key="article.key"
                :sm="24"
                :md="index === 0 ? 24 : 12"
              >
                <ArticleVx
                  :title="article.title"
                  :desc="article.summary"
                  :date="article.publishedDate"
                  :size="null"
                  :link="article.url"
                  :tags="article.tags"
                  :watchlist-tags="watchlistTags"
                  :author="article.author"
                  :class="{ 'bot-line': index === 0 }"
                  :has-access="hasAccessArticle"
                />
              </el-col>
            </el-row>
          </div>
          <!-- /FEATURED -->
          <!-- RECOMMENDED -->
          <div
            v-if="recommended && recommended.length"
            class="main__featured section section-border--top section-border--right section-border--bottom"
          >
            <TitleBlock :text="'Recommended for you'" color="corporateblue" />
            <el-row>
              <el-col
                v-for="(article, index) in recommended"
                :key="article.key"
                :sm="24"
                :md="12"
              >
                <ArticleVx
                  :title="article.title"
                  :desc="article.summary"
                  :date="article.publishedDate"
                  :size="null"
                  :link="article.url"
                  :tags="article.tags"
                  :author="article.author"
                  :watchlist-tags="watchlistTags"
                  :class="{ 'bot-line': index < 2 }"
                  :has-access="hasAccessArticle"
                />
              </el-col>
            </el-row>
          </div>
          <!-- /RECOMMENDED -->
          <!-- HORIZON SCANNING -->
          <div
            v-if="checkMapAccess() && !mapData.forbidden && (featured && featured.length)"
            class="main__featured section section-border--top section-border--right section-border--bottom"
            style="padding-right: 0rem"
          >
            <div id="hs-map-block" style="position: relative; height: 600px">
              <div
                style="position: relative; width: 100%; z-index: 999"
                class="title-block title-block__size--default title-block__color--gold title-spacing"
              >
                <h2 class="title-block__text">HORIZON SCANNING</h2>
              </div>
              <!-- Never reformat the line below, keep style on one line, if formatting this file be careful it may bugger up the map on the homepage -->
              <div
                style="
                  position: relative;
                  height: 600px;
                  width: 100%;
                  margin-top: -56px;
                "
              >
                <HsMap :map-data="mapData" />
              </div>
            </div>
          </div>
          <!-- HORIZON SCANNING -->
          <div
            v-if="regulatoryAnalysis && regulatoryAnalysis.length"
            class="main__featured section section-border--top section-border--right section-border--bottom"
          >
            <TitleBlock :text="'Regulatory Analysis'" color="corporateblue" />
            <el-row>
              <el-col
                v-for="article in regulatoryAnalysis.slice(0, 2)"
                :key="article.key"
                :sm="24"
                :md="12"
              >
                <ArticleVx
                  :title="article.title"
                  :desc="article.summary"
                  :date="article.publishedDate"
                  :size="null"
                  :link="article.url"
                  :tags="article.tags"
                  :author="article.author"
                  :watchlist-tags="watchlistTags"
                  :has-access="hasAccessArticle"
                />
              </el-col>
            </el-row>
          </div>

          <div
            v-if="!guides.forbidden || (guides && guides.length)"
            class="main__featured section section-border--top section-border--right section-border--bottom"
          >
            <TitleBlock :text="'Reports'" color="corporateblue" />
            <div class="guides-container">
              <div
                v-for="(article, index) in guides.slice(0, 4)"
                :key="article.key"
                class="area"
                :class="`area-${index + 1}`"
              >
                <Guide
                  :title="article.title"
                  :desc="index === 0 && index === 3 ? article.summary : null"
                  :date="article.publishedDate"
                  :link="article.relativeLink"
                  :author="article.author"
                />
              </div>
            </div>
          </div>
          <div
            v-if="insights && insights.length"
            class="main__featured section section-border--top section-border--right section-border--bottom"
          >
            <TitleBlock :text="'Insights'" color="corporateblue" />
            <el-row>
              <el-col
                v-for="(article, index) in insights"
                :key="article.key"
                :sm="24"
                :md="12"
              >
                <ArticleVx
                  :title="article.title"
                  :desc="index < 2 ? article.summary : null"
                  :date="article.publishedDate"
                  :size="index > 1 ? 'small' : null"
                  :link="article.url"
                  :author="article.author"
                  :tags="article.tags"
                  :class="{ 'bot-line': index < 4 }"
                  :has-access="hasAccessArticle"
                />
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="column column--1-3">
          <div class="main__sidebar">
            <!-- HS UPDATES BLOCK-->
            <HsUpdates v-if="hasHSAccess && weekCount && weekCount.watchlistJurisdictions">
              <div class="main__vixio">
                <div
                  class="main__vixio-list section-border--top section-border--right section-border--bottom"
                >
                <!-- http://vue.pc.loc:8005/search?filter%5Bauthorities%5D%5B%5D=1516-->
                  <div class="hsupdates">
                    <div><img class="hsupdates__icon" height="24" width="24" src="../../assets/icons/globe.svg" alt="globe" /></div>
                    <div class="hsupdates__total">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalHsUpdates : fortnightCount?.hsUpdates?.totalHsUpdates }}</div>
                    <div v-if="dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null" class="hsupdates__description" >
                      {{ weekCount.hsUpdates.totalHsUpdates == 0 ? 'No ' : ''}}Horizon Scanning updates for your Watchlists in the last 7 days
                    </div>
                    <div v-else class="hsupdates__description" >
                      {{ fortnightCount.hsUpdates.totalHsUpdates == 0 ? 'No ' : ''}}Horizon Scanning updates for your Watchlists in the last 14 days
                    </div>
                    <div class="hsupdates__actionable">
                      <div @click="trackCategoryClicked('Actionable','search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5267')">Actionable:</div> <span class="count">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalActionable : fortnightCount?.hsUpdates?.totalActionable }}</span>
                    </div>
                    <div class="hsupdates__indicative">
                      <div @click="trackCategoryClicked('Indicative','search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5268')">Indicative:</div> <span class="count">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalIndicative : fortnightCount?.hsUpdates?.totalIndicative }}</span>
                    </div>
                    <div class="hsupdates__informative">
                      <div @click="trackCategoryClicked('Informative','search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5269')">Informative:</div> <span class="count">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalInformative : fortnightCount?.hsUpdates?.totalInformative }}</span>
                    </div>
                    <div class="hsupdates__viewlatest">
                      <div class="hsupdates__viewlatest-link" @click="trackCategoryClicked('View Latest Updates','regulatory_updates')">View Latest Updates</div>
                    </div>
                  </div>
                </div>
              </div>
            </HsUpdates>

            <HsUpdates v-if="hasHSAccess && weekCount && !weekCount.watchlistJurisdictions">
              <div class="main__vixio">
                <div
                  class="main__vixio-list section-border--top section-border--right section-border--bottom"
                >
                <!-- http://vue.pc.loc:8005/search?filter%5Bauthorities%5D%5B%5D=1516-->
                  <div class="hsupdates">
                    <div><img class="hsupdates__icon" height="24" width="24" src="../../assets/icons/globe.svg" alt="globe" /></div>
                    <div class="hsupdates__total">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalHsUpdates : fortnightCount?.hsUpdates?.totalHsUpdates }}</div>
                    <div v-if="dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null" class="hsupdates__description" >
                      {{ weekCount.hsUpdates.totalHsUpdates == 0 ? 'No ' : ''}}Horizon Scanning updates for your jurisdictions in the last 7 days
                    </div>
                    <div v-else class="hsupdates__description" >
                      {{ fortnightCount.hsUpdates.totalHsUpdates == 0 ? 'No ' : ''}}Horizon Scanning updates for your jurisdictions in the last 14 days
                    </div>
                    <div class="hsupdates__actionable">
                      <div @click="trackCategoryClicked('Actionable','search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5267')">Actionable:</div> <span class="count">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalActionable : fortnightCount?.hsUpdates?.totalActionable }}</span>
                    </div>
                    <div class="hsupdates__indicative">
                      <div @click="trackCategoryClicked('Indicative','search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5268')">Indicative:</div> <span class="count">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalIndicative : fortnightCount?.hsUpdates?.totalIndicative }}</span>
                    </div>
                    <div class="hsupdates__informative">
                      <div @click="trackCategoryClicked('Informative','search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5269')">Informative:</div> <span class="count">{{ dataUser.daysSincePreviousLogin <= 7 && dataUser.daysSincePreviousLogin !== null ? weekCount?.hsUpdates?.totalInformative : fortnightCount?.hsUpdates?.totalInformative }}</span>
                    </div>
                    <div class="hsupdates__viewlatest">
                      <div class="hsupdates__viewlatest-link" @click="trackCategoryClicked('View Latest Updates','regulatory_updates')">View Latest Updates</div>
                    </div>
                  </div>
                </div>
              </div>
            </HsUpdates>
            <!-- /HS UPDATES BLOCK-->
            <Sidebar :props-handle-click-close="toggleSidebar" class="test">
              <!-- VIXIO PICKS -->
              <div v-show="picks && picks.length" class="main__vixio">
                <div
                  class="main__vixio-list section-border--top section-border--right section-border--bottom"
                >
                  <TitleBlock :text="'VIXIO Picks'" color="corporateblue" />
                  <MustRead
                    v-for="(item, index) in picks"
                    :key="index"
                    :text="item.title"
                    :number="index + 1"
                    :link="item.url"
                  />
                </div>
              </div>
              <!-- /VIXIO PICKS -->
              <!-- WHATS HOT -->
              <div class="main__hots">
                <div class="main__hots-title">WATCHLIST TRENDING</div>
                <div
                  class="main__hots-content section section-border--top section-border--right section-border--bottom"
                >
                  <div
                    v-for="(item, index) in hot"
                    :key="index"
                    class="main__hots-item"
                  >
                    <div class="main__hots-subtitle">
                      <Tag :text="item.name" />
                    </div>
                    <Range
                      v-for="(range, index2) in item.children"
                      :key="index2"
                      :text="range.name"
                      :width="range.weight"
                      :range="range"
                      :category="item.tid"
                      :tid="range.tid"
                      :jurisdiction="item.tid"
                      :type="range.vid"
                    />
                    <script />
                  </div>
                </div>
              </div>

              <!--Global Trending -->
              <div class="main__hots">
                <div class="main__hots-title">GLOBAL TRENDING</div>
                <div
                  class="main__hots-content section section-border--top section-border--right section-border--bottom"
                >
                  <div
                    v-for="(item, index) in hotGlobal"
                    :key="index"
                    class="main__hots-item"
                  >
                    <div class="main__hots-subtitle">
                      <Tag :text="item.name" />
                    </div>
                    <Range
                      v-for="(range, index2) in item.children"
                      :key="index2"
                      :text="range.name"
                      :width="range.weight"
                      :link="range"
                      :category="item.tid"
                      :tid="range.tid"
                      :jurisdiction="item.tid"
                      :type="range.vid"
                    />
                  </div>
                </div>
              </div>
            </Sidebar>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { hots } from "../../mixin/hots";
import { checkAccess } from "@/utils/constants";

export default {
  name: "HomepageV1",
  components: {
    ChecklistOverview: () =>
      import("../checklists/ChecklistOverview"),
    // Title: () => import("../elements/Title"),
    TextContent: () => import("../elements/TextContent"),
    TitleBlock: () => import("../elements/TitleBlock"),
    ArticleVx: () => import("../elements/Article"),
    Guide: () => import("../elements/Guide"),
    Sidebar: () => import("../sidebar/Sidebar"),
    MustRead: () => import("../elements/MustRead"),
    Range: () => import("../elements/Range"),
    Tag: () => import("../elements/Tag"),
    HsMap: () => import("../maps/HorizonScanningMap"),
    HsUpdates: () => import("../elements/HsUpdates"),
  },
  mixins: [hots],
  data() {
    return {
      aggregations: {},
      transformToPopup: true,
      showFilters: false,
    };
  },
  async fetch({ store }) {
    await Promise.all([
      store
        .dispatch("Main/getViewData", {
          url: "/basic-page?page=/page/payments-compliance",
        })
        .then(({ data }) => {
          if (data && data.nid) {
            store.commit("PageView/appendData", {
              label: "nids",
              data: data.nid,
            });
          }
          store.commit("PageView/setReady", {});
          store.commit("Main/setData", {
            label: "basicPage",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Main/getViewData", {
          url: "/featured",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "featured",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Main/getViewData", {
          url: "/insights/featured",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "insights",
            data,
          });
        })
        .catch((error) => {
          store.commit("Main/setData", {
            label: "insights",
            data: { forbidden: true, error },
          });
        }),
      store
        .dispatch("Main/getViewData", {
          url: "/recommended/all",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "recommended",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Main/getViewData", {
          url: "/analysis/featured",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "regulatoryAnalysis",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Main/getViewData", {
          url: "/guides/featured",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "guides",
            data,
          });
        })
        .catch((error) => {
          store.commit("Main/setData", {
            label: "guides",
            data: { forbidden: true, error },
          });
        }),
      store
        .dispatch("Main/getViewData", {
          url: "/updates/featured",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "horizonScanning",
            data,
          });
        })
        .catch((error) => {
          store.commit("Main/setData", {
            label: "horizonScanning",
            data: { forbidden: true, error },
          });
        }),
      store
        .dispatch("Main/getViewData", {
          url: "/promoted",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "picks",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Main/getViewData", {
          url: "/watchlist-tags",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "watchlistTags",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Updates/getViewData", {
          url: "/horizon-scanning/map-data",
        })
        .then(({ data }) => {
          store.commit("Updates/setData", {
            label: "mapData",
            data,
          });
        })
        .catch((error) => {
          store.commit("Updates/setData", {label: "mapData", data: {forbidden: true, error }});
          // if (error.response.status === 403) {
           // store.commit("Main/setAccessForbidden", {label:"accessForbidden", data: {horizonScanningMapData: false}});
          // } else {
           // console.error(error);
          // }
          }),
      store
        .dispatch("Main/getViewData", {
          url: "/whatshot?params[user]=1",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "hot",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Main/getViewData", {
          url: "/whatshot",
        })
        .then(({ data }) => {
          store.commit("Main/setData", {
            label: "hotGlobal",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Updates/getViewData", {
          url: "/horizon-scanning/global-updates?days=7",
        })
        .then(({ data }) => {
          store.commit("Updates/setData", {
            label: "weekCount",
            data,
          });
        })
        .catch((error) => console.error(error)),
      store
        .dispatch("Updates/getViewData", {
          url: "/horizon-scanning/global-updates?days=14",
        })
        .then(({ data }) => {
          store.commit("Updates/setData", {
            label: "fortnightCount",
            data,
          });
        })
        .catch((error) => console.error(error)),
      // Only run this if we have workspace access, thus the slightly odd syntax for including it!
      ...(store.getters["Auth/workspaceAccess"]
        ? [
          store
            .dispatch("Workspace/getViewData", {
              url: "/workspace/overview",
            })
            .then(({ data }) => {
              if (!Array.isArray(data)) {
                store.commit("Workspace/setData", {
                  label: "checklistsOverview",
                  data,
                });
              }
            })
            .catch((error) => console.error(error)),
          store
            .dispatch("Workspace/getViewData", {
              url: "/workspace/checklists",
            })
            .then(({ data }) => {
              if (Array.isArray(data)) {
                store.commit("Workspace/setData", {
                  label: "checklists",
                  data,
                });
              }
            })
            .catch((error) => console.error(error)),
          ]
        : []),
    ]);
  },
  head() {
    return {
      title: "VIXIO PaymentsCompliance",
    };
  },
  computed: {
    ...mapState("Updates", ["mapData","weekCount","fortnightCount"]),
    ...mapState("Main", [
      "basicPage",
      "featured",
      "regulatoryAnalysis",
      "guides",
      "horizonScanning",
      "picks",
      "hot",
      "hotGlobal",
      "specialism",
      "sector",
      "jurisdiction",
      "recommended",
      "insights",
      "watchlistTags",
    ]),
    ...mapState("Global", ["filters"]),
    ...mapState("Auth", ["subscriptions"]),
    ...mapState("Profile", ["dataUser", "userAccess"]),
    hasAccessArticle(state) {
      return checkAccess(state.subscriptions.legacy_permissions, "viewArticle") ||
        checkAccess(state.subscriptions.permissions, "updates") ||
        checkAccess(state.subscriptions.permissions, "analysis");
    },
    hasHSAccess(state) {
      return (
        checkAccess(
          state.subscriptions.legacy_permissions,
          "viewHorizonScanning"
        ) || checkAccess(state.subscriptions.permissions, "hs")
      );
    },
  },
  created() {
    this.$store.commit("PageView/willSetData");
  },
  methods: {
    trackCategoryClicked(category, url) {
      if (this.$matomo) {
        this.$matomo.trackEvent("Search", "Home page category link", category);
      }
      this.$router.push(url);
    },
    lastLoggedIn() {
      // Mocked for the moment, we do need to get this from the API
      // return this.$store.state.Auth.lastLoggedIn;
      return 7;
    },
    checkMapAccess() {
      return checkAccess(
        this.$store.state.Auth.subscriptions.legacy_permissions,
        "viewHorizonScanning") || checkAccess(
        this.$store.state.Auth.subscriptions.permissions,
        "hs");

    },
    checkIfFirst(key) {
      if (key === 0) {
        return "bottom-line";
      }
    },
    updateEnabledFilters() {
      // TODO to be implemented
    },
    getActiveFilters() {},

    toggleSidebar() {
      this.showFilters = !this.showFilters;
      if (this.showFilters) {
        document.documentElement.classList.add("lock-scroll_only-devices");
      } else {
        document.documentElement.classList.remove("lock-scroll_only-devices");
      }
    },
    extractPaths(labels, paths) {
      const regex = /<a.+?\s*href\s*=\s*["\']?([^"\'\s>]+)["\']?/gi;
      const str = paths.replace(/\\/g, "");

      const labelArr = labels.split(", ");

      const linksArray = [...str.matchAll(regex)];

      const data = [];

      for (const key in linksArray) {
        const newItem = { text: labelArr[key], link: linksArray[key][1] };
        data.push(newItem);
      }
      return data;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/home/variables";
@import "../../assets/styles/helpers/mixin";

.bot-line {
  border-bottom: 1px solid $botLineColour;
}

.side_ban {
  max-width: 140px;
}

#hs-map-block .title-block__size--default {
  height: 3.6rem;
}

#hs-map-block .title-block {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
}

#hs-map-block .title-spacing {
  margin-bottom: 2rem;
}

#hs-map-block .title-block__color--gold .title-block__text {
  color: #ffffff;
  background-color: $mapBlockBackgroundColor;
}

#hs-map-block .title-block__size--default .title-block__text {
  font-size: 1.6rem;
  line-height: 3.6rem;
  padding: 0 1.5rem;
}

#hs-map-block .title-block__text {
  font-weight: 700;
  text-transform: uppercase;
  z-index: 1;
  position: relative;
}

#hs-map-block .title-block__color--gold .title-block__text:after {
  border-top-color: $mapBlockBorderColor;
}

#hs-map-block .title-block__size--default .title-block__text:after {
  border-top-width: 3.6rem;
}

#hs-map-block .title-block__text:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-top: 3.6rem solid;
  border-right: 1.3rem solid transparent;
  right: -1.3rem;
  top: 0;
  bottom: 0;
}

#hs-map-block .leaflet-top {
  top: auto !important;
  bottom: 20px !important;
}

.leaflet-control-attribution {
  display: none !important;
}

#hs-map-block .leaflet-container {
  background-color: $mapBlockLeafletContainer !important;
}

.header {
  &__section {
    @include above($lg) {
      background: url("../../assets/images/banners/VIXIO__PC__1_0_Home__1440x250.jpg")
        no-repeat;
      background-position: right center;
      background-size: cover;
      background-color: $bannerBackgroundBlue;
      display: block;
      min-height: 20rem;
    }
    // display: none;
    // padding: 2rem;
    margin-bottom: 2rem;

    .text-content {
      max-width: 62rem;
      color: $white;
      border: 1px dashed $brightGreen;
      border-left: none;
      padding: 2rem 4rem 2rem 0;
    }
  }
}

.home {
  &__header {
    background-color: transparent;
    padding: 4rem;
  }

  .title-block {
    // margin-bottom: 2rem;
    &__text {
      text-transform: none !important;
    }
  }

  .text-content {
    margin-bottom: 2rem;
    @include above($lg) {
      margin-right: 50rem;
    }
    color: $white;
  }
}

.main {
  &__featured,
  &__data,
  &__recommended {
    padding-right: 4.5rem;
    @include below($md) {
      padding-right: 0;
    }
  }

  &__updates {
    padding-right: 4.5rem;
    border-left: 1px solid $border;
    @include below($md) {
      padding-right: 0;
    }

    .update {
      margin-left: 2rem;
      margin-bottom: 2.4rem;
      padding-right: 22rem;
      @include below($md) {
        padding-right: 1.6rem;
      }
    }
  }

  &__vixio {
    margin-bottom: 2.4rem;

    .must-read {
      border-bottom: 1px solid $border;
      padding: 1.6rem 1rem 1rem 1.6rem;

      &:last-of-type {
        border-bottom: none;
      }
    }

    &-title {
      font-size: 1.6rem;
      font-weight: 700;
      text-transform: uppercase;
    }

    &-list {
      background: $vixioPicksListBackground;
      background: lighten($brightBlue, 45%);
    }
  }

  &__hots {
    &-title {
      font-size: 1.6rem;
      font-weight: 700;
      text-transform: uppercase;
    }

    &-content {
      padding: 1.6rem 0 1rem;
    }

    &-subtitle {
      border-bottom: 1px solid $border;
    }

    &-item:not(:last-of-type) {
      margin-bottom: 2rem;
    }
  }

  &__banners {
    @include below($lg) {
      .column:not(:last-of-type) {
        margin-bottom: 1rem;
      }
    }
  }

  &__pool {
    margin-bottom: 3rem;
  }

  .main__banners {
    .tag {
      background-color: $mainBannersColor !important;
    }
  }
}

.must-read {
  display: flex;
  position: relative;

  &__number {
    font-size: 4.2rem;
    font-weight: 300;
    color: $corporateBlue;
    margin-right: 3rem;
    width: 2rem;
  }

  &__title {
    width: calc(100% - 2rem);

    a {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 700;
      color: $text_gray;
      text-decoration: none;
    }
  }
}

.guides-container {
  padding-bottom: 3.2rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 1rem 4rem;
  grid-template-areas:
    "area-1 area-2 area-4"
    "area-1 area-3 area-4";

  @include below($md) {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }

  .area {
    @include below($md) {
      width: 100%;
    }

    &-1 {
      grid-area: area-1;
    }

    &-2 {
      grid-area: area-2;
    }

    &-3 {
      grid-area: area-3;
    }

    &-4 {
      grid-area: area-4;
    }
  }
}

.hsupdates {
  padding: 2rem;

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: #262053;
  }

  &__title {
    font-size: 1.6rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__total {
    padding-top: 2rem;
    font-size: 2.3rem;
    font-weight: 800;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__description {
    font-size: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 2rem;
    text-align: center;
  }

  &__actionable {
    font-size: 1.8rem;
    font-weight: 900;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $actionable;
    cursor: pointer;
  }

  &__indicative {
    font-size: 1.8rem;
    font-weight: 900;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
      color: $indicative;
  }

  &__informative {
    font-size: 1.8rem;
    font-weight: 900;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
      color: $informative;
  }

  &__viewlatest-link {
    padding-top: 2rem;
    font-size: 1.8rem;
    color: $corporateBlue;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.count {
  color: black;
  margin-left: 1rem;
}
</style>
